import React, { memo } from "react";

import SvgIcon from "@material-ui/core/SvgIcon";

const SubHeaderWarning = ({ className }) => (
  <SvgIcon className={className} viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="8" fill="#DC0032" />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="3"
      y="2"
      width="10"
      height="10"
    >
      <path d="M3.33337 2.66663H12.6667V12H3.33337V2.66663Z" fill="#C4C4C4" />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M12.5439 10.0992L8.8555 3.61807C8.68689 3.31245 8.37073 3.1333 8.00189 3.1333C7.63305 3.1333 7.32743 3.31245 7.14828 3.61807L3.45983 10.0992C3.29122 10.4048 3.29122 10.7736 3.45983 11.0793C3.62845 11.3849 3.9446 11.564 4.30291 11.564H11.6693C12.0276 11.564 12.3437 11.3849 12.5123 11.0793C12.7126 10.7736 12.7126 10.4048 12.5439 10.0992ZM8.53935 10.0254H7.55928V9.17181H8.53935V10.0254ZM8.53935 8.6765H7.55928V6.23159H8.53935V8.6765Z"
        fill="white"
      />
    </g>
  </SvgIcon>
);

export default memo(SubHeaderWarning);
